import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import {
  getAccessToken,
  getRefreshToken,
  setTokens,
} from '../../features/Auth/applications/localStorages/tokenLocalStorage';

const tokenUrl = `${process.env.REACT_APP_TOKEN_URL}`;

const interceptors = {
  refreshToketRetryCount: 0,
  onRequest: (config: AxiosRequestConfig): AxiosRequestConfig => {
    const token = getAccessToken();
    if (!config.headers) config.headers = {};
    if (token && config.url !== tokenUrl) {
      config.headers.Authorization = 'Bearer ' + token;
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  onRequestError: (error: AxiosError): Promise<AxiosError> => Promise.reject(error),
  onResponse: (response: AxiosResponse): AxiosResponse => {
    //if success and its not from token url
    if (response.status === 201 || response.status === 200) {
      if (response.config.url !== tokenUrl) {
        interceptors.refreshToketRetryCount = 0;
      }
    }
    return response;
  },
  onResponseError: (
    error: AxiosError
  ): Promise<AxiosError<unknown, any> | AxiosResponse<any, any> | undefined> => {
    const originalRequest = error.config;
    // debugger;

    if (error.response?.status === 403) {
      //if 403 and its not from token url
      const event = new Event('REDIRECT_TO_FORBIDDEN');
      window.dispatchEvent(event);
      return Promise.reject(error);
    }
    if (error?.response?.status === 400 && originalRequest.url === tokenUrl) {
      const event = new Event('REDIRECT_TO_LOGIN');
      window.dispatchEvent(event);

      return Promise.reject(error);
    }

    if (
      error?.response?.status === 401 &&
      error.config.url !== tokenUrl &&
      interceptors.refreshToketRetryCount < 2
    ) {
      interceptors.refreshToketRetryCount++;
      const refreshToken = getRefreshToken();
      if (!refreshToken) {
        const event = new Event('REDIRECT_TO_LOGIN');
        window.dispatchEvent(event);
        return Promise.reject(error);
      }

      const params = new URLSearchParams();
      params.append('client_id', 'loyalty-api');
      params.append('grant_type', 'refresh_token');
      params.append('refresh_token', refreshToken);
      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      };

      return axios.post(tokenUrl, params, config).then((res) => {
        if (res.status === 201 || res.status === 200) {
          setTokens({
            access_token: res.data.access_token,
            refresh_token: res.data.refresh_token,
          });
          axios.defaults.headers.common.Authorization = 'Bearer ' + getAccessToken();
          return axios(originalRequest);
        }
      });
    }

    return Promise.reject(error);
  },
};

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
  axiosInstance.interceptors.request.use(interceptors.onRequest, interceptors.onRequestError);
  axiosInstance.interceptors.response.use(interceptors.onResponse, interceptors.onResponseError);
  return axiosInstance;
}

setupInterceptorsTo(axios);
